import {connect} from "react-redux";
import {emphasize, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {Navigate, useNavigate} from "react-router-dom";
import {useState, useEffect} from "react";
import {App} from "../App";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
    orderSubscription,
  }) => ({
    i18n,
    isLoading,
    orderSubscription,
  }),
  {
    // redux functions
  }
)((props) => {
  let i18n = props.i18n;
  const [deadline, setDeadline] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    // Calculate the current date
    const currentDate = new Date();

    // Add 30 days to the current date
    const deadlineDate = new Date(currentDate);
    deadlineDate.setDate(currentDate.getDate() + 30);

    // Format the date as dd.mm.yyyy
    const day = String(deadlineDate.getDate()).padStart(2, "0");
    const month = String(deadlineDate.getMonth() + 1).padStart(2, "0");
    const year = deadlineDate.getFullYear();

    const formattedDate = `${day}.${month}.${year}`;

    // Set the deadline state
    setDeadline(formattedDate);
  }, []);

  return (
    <>
      <div className="card-info">
        <Typography variant="h1">{i18n.order_title}</Typography>
        <p>
          <img className="icon" src="../images/check_circle.svg" />
          Ihre Bestellung für 247UpTime Professional Web (#
          {props.orderSubscription.orderNumber}) ist erfolgreich bei uns
          eingegangen. Wir senden Ihre Vertragsunterlagen umgehend an{" "}
          {props.orderSubscription.email}.
        </p>
        <p>
          <img className="icon" src="../images/warning.svg" />
          Bitte senden Sie uns die unterschriebenen Vertragsunterlagen bis
          spätens {""}
          {deadline} (30 Tage Frist) elektronisch an
          247uptime@247factorynet.com.
        </p>

        <Button
          variant="contained"
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          Zurück Zum Dashboard
        </Button>
      </div>
    </>
  );
});
